export enum ChartColor {
  Yellow = "#F1A533",
  Blue = "#004289",
  DarkGrey = "#616161",
  Red = "#E4002B",
  LightGrey = "#C1C1C1",
  Green = "#42775A",
}
